<div class="info-message__container">
    <div class="info-icon__block">
        <vn-icon name="theme-info-i" size="16" class="info-icon"></vn-icon>
    </div>
    <div class="info-message__block">
        <div class="info-message__title">{{ infoHeaderTitle }}</div>
        <div class="info-message__content">
            <div class="info-message-content__header">{{ infoHeader }}</div>
            <div class="info-message-content__text" [innerHtml]="infoMessage"></div>
            <div class="info-message-content__button" (click)="closeClick()">{{ sitecore.betslip.messages.BetbuilderComboInfoButton }}</div>
        </div>
    </div>
</div>
